import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=d974d46e&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=d974d46e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d974d46e",
  null
  
)

export default component.exports